const PREFIX = "Datasets";
export const IS_CONTENT_LOADING = `${PREFIX}_IS_CONTENT_LOADING`;
export const SET_SINGLE_IMAGE_DATA = `${PREFIX}_SET_SINGLE_IMAGE_DATA`;
export const SET_SINGLE_IMAGE_LABELS = `${PREFIX}_SET_SINGLE_IMAGE_LABELS`;
export const SET_SINGLE_IMAGE_ISSUES = `${PREFIX}_SET_SINGLE_IMAGE_ISSUES`;
export const SET_HOVERED_OBJECT_LABEL = `${PREFIX}_SET_HOVERED_OBJECT_LABEL`;
export const SET_SELECTED_OBJECT_LABELS = `${PREFIX}_SET_SELECTED_OBJECT_LABELS`;
export const SET_IMAGE_CUSTOM_METADATA = `${PREFIX}_SET_IMAGE_CUSTOM_METADATA`;
